
import moment from 'moment';
import PhoneInput from "react-phone-number-input";
import { useDispatch, useSelector } from 'react-redux';
import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import { Business, EmailOutlined, Person2Outlined, PhoneOutlined, WorkOutline } from '@mui/icons-material';

import EnterCode from '../../modals/enterCode';
import ChangePassword from '../ChangePassword';
import { updateUser } from '../../../reducers/userReducer';
import { postRequest, showMessage } from '../../../config';
import { toggleModal } from '../../../reducers/modalReducer';

const ProfileForm = forwardRef(({ userData, Button }, ref) => {
  // Hooks and vars 
  const dispatch = useDispatch()
  const { smsEnabled, twoFaEnabled, emailEnabled } = useSelector((state) => state.loginType);
  const [counter, setCounter] = useState(0); // Countdown for 60s
  const [verify, setVerify] = useState(null);
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [linkedIn, setLinkedIn] = useState('');
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [designation, setDesignation] = useState('');

  const buttonText = useMemo(() => {
    return counter > 0 ? `Resend in ${counter}s` : 'Resend Code';
  }, [counter]);

  const isButtonDisabled = useMemo(() => {
    return counter > 0 || loading;
  }, [counter, loading]);

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [counter]);

  useEffect(() => {
    if (firstName == '') setFirstName(userData['firstName']);
    if (lastName == '') setLastName(userData['lastName']);
    if (email == '') setEmail(userData['email']);
    if (phone == '') setPhone(userData['phone'] || '');
    if (linkedIn == '') setLinkedIn(userData['linkedIn'] || '');
    if (designation == '') setDesignation(userData['designation'] || userData['title'] || userData['job'] || '');
  }, [userData]);

  const onSubmitData = async () => {
    if (firstName == '') return showMessage(`Please enter the first name`);
    if (lastName == '') return showMessage(`Please enter the last name`);
    if (email == '') return showMessage(`Please enter the email`);
    // if (linkedIn == '') return showMessage(`Please enter the linkedIn`);
    setLoading(true);
    try {
      // let regex = /^http(s)?:\/\/([\w]+\.)?linkedin\.com\/in|company\/[A-z0-9_-]+\/?/;
      // if (linkedIn && linkedIn.length > 0) {
      //   let isValid = regex.test(linkedIn)
      //   if (!isValid) {
      //     return showMessage("Please provide a valid linkedin profile url");
      //   }
      // }

      // if (phone && !userData['smsEnabled']) {
      //   return showMessage("Please verify phone number");
      // }

      const res = await postRequest(`/user/updateProfile`, {
        _id: userData['_id'],
        firstName,
        lastName,
        ...(userData['email'] !== email && { newEmail: email }),
        phone,
        linkedIn,
        designation
      });
      if (!res || res["code"] != 200) return;
      showMessage(res["message"]);
      dispatch(updateUser({
        ...userData,
        firstName,
        lastName,
        phone,
        linkedIn,
        designation,
        updatedAt: new Date(),
        ...(phone !== userData['phone'] && { smsEnabled: false, phoneVerified: false }),
      }))
    } catch (e) {
      showMessage('An error occurred while submitting the form');
    } finally {
      setLoading(false)
    }
  };

  const handleVerification = async () => {
    try {
      if (!phone || phone == '') return showMessage('Please enter a phone number')
      setLoading(true)
      const res = await postRequest("/user/sendSMS", { phone });
      if (res['code'] == 200) {
        setCounter(60);
        setVerify("Phone");
        dispatch(toggleModal({ open: "verify" }));
      }
      showMessage(res["message"]);
    } catch (e) { showMessage(e["message"]) }
    finally { setLoading(false) }
  };

  const verifySMSCode = async (e) => {
    const authKey = e.target.value;
    if (authKey.length < 6) return;
    setLoading(true)
    try {
      const response = await postRequest("/user/enableSMS", { authKey });
      if (response.code == 200) {
        dispatch(updateUser({ ...userData, smsEnabled: true }))
        dispatch(toggleModal({ open: "" }));
      }
      showMessage(response["message"]);
    } catch (e) {
      console.log(e, "e")
      showMessage(e["message"]);
    } finally {
      setLoading(false)
    }
  };

  return (
    <div className="w100 lg-w100 md-px1rem">
      <form className='bg38 p2rem br20px sm1rem' style={{ borderRadius: '0 0 24px 24px', paddingTop: '0', marginTop: '-33px' }}>
        <h2 className='c15 fw600 fs1rem'>Personal Information</h2>
        <div className='df aic jcsb'>
          <div className="df aic w50 mr0-5rem pr">
            <Person2Outlined className='pa c2' style={{ left: '15px', marginTop: '0.8rem', color: `${firstName && firstName.length > 0 ? '#000' : '#505050'}` }} />
            <input className={`w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ${firstName && firstName.length > 0 ? 'bo42' : 'bo4'}`}
              value={firstName} onChange={(e) => setFirstName(e.target.value)} id="firstName" placeholder="First Name" type="url" />
          </div>
          <div className="w50">
            <input className={`w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl1rem ${lastName && lastName.length > 0 ? 'bo42' : 'bo4'}`}
              value={lastName} onChange={(e) => setLastName(e.target.value)} id="lastName" placeholder="Last Name" type="url" />
          </div>
        </div>
        {
          userData?.['companyId']?.['cName'] ? <div className="df aic w100 pr">
            <Business className='pa c2' style={{ left: '15px', marginTop: '0.8rem', color: `#505050` }} />
            <input
              className={`w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem`}
              value={userData?.['companyId']?.['cName'] ?? ""}
              disabled={true}
              type="text"
              placeholder="Company Name"
            />
          </div> : null
        }


        <div className="df aic w100 pr">
          <EmailOutlined className='pa c2' style={{ left: '15px', marginTop: '0.8rem', color: `${email && email.length > 0 ? '#000' : '#505050'}` }} />
          <input className={`w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ${email && email.length > 0 ? 'bo42' : 'bo4'}`}
            value={email} onChange={(e) => setEmail(e.target.value)} id="email" type="url" placeholder="Email" />
          <svg className='pa c2' style={{ right: '15px', marginTop: '0.8rem', display: `${userData?.emailVerified ? 'block' : 'none'}` }} width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.2143 0C6.84643 0 0 6.84643 0 15.2143C0 23.5821 6.84643 30.4286 15.2143 30.4286C23.5821 30.4286 30.4286 23.5821 30.4286 15.2143C30.4286 6.84643 23.5821 0 15.2143 0ZM21.7564 11.5629L14.7579 20.6914C14.4536 20.9957 13.9971 21.3 13.5407 21.3C13.0843 21.3 12.6279 21.1479 12.3236 20.6914L8.67214 15.975C8.21571 15.3664 8.21571 14.3014 8.97643 13.845C9.73714 13.3886 10.65 13.3886 11.1064 14.1493L13.5407 17.3443L19.3221 9.73714C19.7786 9.12857 20.8436 8.97643 21.4521 9.43286C22.2129 9.88929 22.2129 10.8021 21.7564 11.5629Z" fill="#02BC7D" />
          </svg>
        </div>
        <div className="df aic w100 pr">
          <PhoneInput
            className={`w100 bg1 bs1px brss bo42 mt0-9rem py0-75rem br8px pl1rem c15`}
            placeholder="Phone"
            value={phone}
            onChange={(e) => setPhone(e)}
          />
          <Button btnType='primary' onClick={handleVerification} text={userData?.smsEnabled ? "Verified" : 'Verify'} style={{ right: "0", marginTop: "0.8rem", borderRadius: "8px", height: "calc(100% - 0.9rem)" }} customClassName={`shadow pa ${userData?.smsEnabled ? "c1 bg3 bg3-hover" : 'c1 bg4 bg4-hover'}`} />
        </div>
        {!userData['smsEnabled'] && <p class='w100 tar fs0-75rem c3 mt0-5rem'>Requires a verified phone number</p>}
        <div className="df aic w100 pr">
          <svg style={{ left: '15px', position: 'absolute', marginTop: '0.8rem', zIndex: 9 }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5984_38509)">
              <path d="M5 17H1V6H5V17ZM1.66663 16.2904H4.33337V6.70964H1.66663V16.2904Z" fill={`${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`} stroke={`${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`} stroke-width="0.5" />
              <path d="M17 17H13V10.9677C13 10.3799 12.5522 9.90321 12 9.90321C11.4476 9.90321 11 10.3799 11 10.9677V17H7V6H11V6.71406C11.6038 6.24937 12.33 5.99948 13.075 6C15.2374 6 17 7.86734 17 10.1649V17ZM13.6666 16.2904H16.3333V10.1649C16.3287 8.25341 14.8706 6.70717 13.075 6.70964C12.2542 6.70964 11.4833 7.07778 10.9083 7.74311L10.3333 8.41285V6.70964H7.66663V16.2904H10.3333V10.9677C10.3333 9.98781 11.0795 9.19357 12 9.19357C12.9204 9.19357 13.6666 9.98781 13.6666 10.9677V16.2904Z" fill={`${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`} stroke={`${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`} stroke-width="0.5" />
              <path d="M3 5C1.89539 5 1 4.10461 1 3C1 1.89551 1.89539 1 3 1C4.10461 1 5 1.89551 5 3C4.99768 4.10364 4.10364 4.9978 3 5ZM3 1.66675C2.26367 1.66675 1.66663 2.26367 1.66663 3C1.66663 3.73645 2.26367 4.33337 3 4.33337C3.73633 4.33337 4.33337 3.73645 4.33337 3C4.33337 2.26367 3.73633 1.66675 3 1.66675Z" fill={`${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`} stroke={`${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`} stroke-width="0.5" />
            </g>
            <defs>
              <clipPath id="clip0_5984_38509">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <input className={`w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ${linkedIn && linkedIn.length > 0 ? 'bo42' : 'bo4'}`}
            value={linkedIn} onChange={(e) => setLinkedIn(e.target.value)} id="linkedIn" placeholder="LinkedIn" type="url" />
        </div>
        <div className="df aic w100 pr">
          <WorkOutline className='pa c2' style={{ left: '15px', marginTop: '0.8rem', color: `${designation && designation.length > 0 ? '#000' : '#505050'}` }} />
          <input className={`w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ttc bo42`}
            value={designation} onChange={(e) => setDesignation(e.target.value)} id="designation" placeholder="Title" type="text" />
        </div>
        <div className='mt1rem w100 tac'>
          <Button
            customClassName="df aic mla mra"
            btnType='warning'
            text={"Confirm User Details"}
            onClick={onSubmitData}
          />
          <p className='fs12px c4 mt0-5rem'>Last edited {moment(userData?.updatedAt).format('DD MMMM, YYYY')}</p>
        </div>
      </form>

      <div className='bg38 p2rem br20px sm1rem mt2rem pr'>
        <h2 className='c15 fw600 fs1-5rem tal w100 mb1rem'>Change Password</h2>
        {/* Changes Password Component */}
        <ChangePassword userData={userData} onSubmitData={onSubmitData} />

        <EnterCode
          modalType={"verify"}
          authMethod={verify}
          codeEntered={verifySMSCode}
          smsEnabled={smsEnabled}
          twoFaEnabled={twoFaEnabled}
          emailEnabled={emailEnabled}
          resendCode={handleVerification}
          loading={loading}
          buttonText={buttonText}
          isButtonDisabled={isButtonDisabled}
          counter={counter}
        />
      </div>

    </div>
  );
});

export default ProfileForm;
